export const ShareSettingsService = Symbol('ShareSettingsService');
